import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true, // Automatically refresh the token before expiry
    persistSession: true, // Persist the session to localStorage
    detectSessionInUrl: true, // Detect session from URL (for email links)
    storage: window.localStorage, // Use localStorage for session persistence
    storageKey: 'bhava-auth-token', // Custom storage key for our app
  }
})

